// Plotly draws chart text (tick labels, hover labels, bar text) from a small HTML subset: <b>, <i>,
// <br>, <span style> and <a href> become SVG. Hover and text templates also replace %{...}
// placeholders with data. So a scenario, queue or plan name a user typed must go through
// escapePlotlyText before it joins a chart string, or it can restyle the chart, add a link, or
// pull in data values for everyone who opens the plan.
//
// Plotly fills in the placeholders first and decodes entities afterwards, so &#37;{y} is shown as
// the literal text %{y}.
var PLOTLY_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '%': '&#37;',
};
export var escapePlotlyText = function (text) { return text.replace(/[&<>%]/g, function (char) { return PLOTLY_ENTITIES[char]; }); };
/**
 * The hover label of a scenario line in the Daily, Interval and Period charts: the scenario name in
 * bold, then "x: value". `valueFormat` is a Plotly placeholder such as `%{y:,.1f}`.
 */
export var scenarioHoverTemplate = function (scenarioName, valueFormat) {
    var name = escapePlotlyText(scenarioName);
    // nosemgrep: javascript.lang.security.html-in-template-string -- name is escaped; valueFormat is a %{y} format we build
    return "<b style=\"color:#fff\">".concat(name, "</b><br><span style=\"color:#fff\">%{x}: ").concat(valueFormat, "</span><extra></extra>");
};
